export default {
  UNKNOWN: 'UNKNOWN',
  ELSTERKZ: 'ELSTERKZ',
  FIELDREF: 'FIELDREF',
  HEADER: 'HEADER',
  FIRSTSUBHEADER: 'FIRSTSUBHEADER',
  MIXED: 'MIXED',
  CUSTOM: 'CUSTOM',
}
